import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { fecthClientList } from "../../../../services/fetchListingData";
import { ACTIVE, APPROVED } from "../../../../utility/constants/valueConstants";
import ResizeListner from "../../../../utility/ResizeListner";
import {
  ClientHeaders,
  ResellerHeaders,
} from "../../../../utility/TableHeaders";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomTable from "../../../components/main_comps/custom_table";
import CustomTabs from "../../../components/main_comps/custom_tabs";
import CommissionModal from "../../../components/ui_comps/CommissionModal";

const tabs = [
  { name: "All", key: 0 },
  { name: "Payin", key: 1 },
  { name: "Payout", key: 2 },
];

const ResellerClients = ({ resellerData }) => {
  const { width, height } = ResizeListner();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const clientListData = useSelector((state) => state.listingSlice.clientList);
  const [clientDataRow, setClientDataRow] = useState(false);
  const [openCommissionModal, setOpenCommissionModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fecthClientList({
        dateRange: "",
        page: 0,
        size: 10,
        userRefId: resellerData?.userId,
        serviceType:
          currentTab === 0
            ? ""
            : currentTab === 1
            ? "payin"
            : currentTab === 2
            ? "payout"
            : "",
        activeStatus: "",
        onBoardedStatus: APPROVED,
      })
    );
  }, [currentTab]);

  return (
    <div style={{}}>
      <CustomTabs
        tabs={tabs}
        activeIndex={currentTab}
        passCurrentTab={(tab) => setCurrentTab(tab)}
      />

      <div style={{ padding: "0px 20px", overflow: "hidden" }}>
        <CustomTable
          styles={{
            maxHeight: height * 0.7,
            minHeight: height * 0.7,
          }}
          data={clientListData?.clients}
          headers={ClientHeaders}
          totalElements={clientListData?.totalRecords}
          totalPages={clientListData?.totalPages}
          currentPage={clientListData?.currentPageNo - 1}
          handlePaginate={(page) => {
            setCurrentPage(page);
            dispatch(
              fecthClientList({
                dateRange: "",
                page: page + 1,
                size: 10,
                userRefId: resellerData?.userId,
                serviceType:
                  currentTab === 0
                    ? ""
                    : currentTab === 1
                    ? "payin"
                    : currentTab === 2
                    ? "payout"
                    : "",
                activeStatus: "",
                onBoardedStatus: APPROVED,
              })
            );
          }}
          onViewMore={(row) => {
            navigate("/clients/details", {
              state: {
                data: row,
              },
            });
          }}
          onViewMoreCommission={(val) => {
            setOpenCommissionModal(true);
            setClientDataRow(val);
          }}
        />
      </div>

      {openCommissionModal && (
        <CustomModal
          headerTitle="Slab Commission"
          open={openCommissionModal}
          onClose={() => {
            setOpenCommissionModal(false);
          }}
          containerStyle={{
            minWidth: 300,
            maxWidth: 400,
            height: "auto",
            maxHeight: 800,
          }}
        >
          <CommissionModal data={clientDataRow} />
        </CustomModal>
      )}
    </div>
  );
};

export default ResellerClients;
